import arrayEquals from "./array-equals"

export default function(obj1, obj2) {
  if (obj1 == null || obj2 == null) {
    return obj1 == obj2
  }
  return arrayEquals(Object.keys(obj1), Object.keys(obj2))
}
